/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "../backdrop/backdrop";
import * as i2 from "../split-pane/split-pane";
import * as i3 from "./menu";
import * as i4 from "../app/menu-controller";
import * as i5 from "../../config/config";
import * as i6 from "../../platform/platform";
import * as i7 from "../../platform/keyboard";
import * as i8 from "../../gestures/gesture-controller";
import * as i9 from "../../platform/dom-controller";
import * as i10 from "../app/app";
var styles_Menu = [];
var RenderType_Menu = i0.ɵcrt({ encapsulation: 2, styles: styles_Menu, data: {} });
export { RenderType_Menu as RenderType_Menu };
export function View_Menu_0(_l) { return i0.ɵvid(2, [i0.ɵqud(402653184, 1, { backdrop: 0 }), (_l()(), i0.ɵeld(1, 0, null, null, 1, "div", [["class", "menu-inner"]], null, null, null, null, null)), i0.ɵncd(null, 0), (_l()(), i0.ɵeld(3, 0, null, null, 1, "ion-backdrop", [["disable-activated", ""], ["role", "presentation"], ["tappable", ""]], null, null, null, null, null)), i0.ɵdid(4, 16384, [[1, 4]], 0, i1.Backdrop, [i0.ElementRef, i0.Renderer], null, null)], null, null); }
export function View_Menu_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 4, "ion-menu", [["role", "navigation"]], null, null, null, View_Menu_0, RenderType_Menu)), i0.ɵprd(6144, null, i2.RootNode, null, [i3.Menu]), i0.ɵdid(2, 245760, null, 2, i3.Menu, [i4.MenuController, i0.ElementRef, i5.Config, i6.Platform, i0.Renderer, i7.Keyboard, i8.GestureController, i9.DomController, i10.App], null, null), i0.ɵqud(335544320, 1, { menuContent: 0 }), i0.ɵqud(335544320, 2, { menuNav: 0 })], function (_ck, _v) { _ck(_v, 2, 0); }, null); }
var MenuNgFactory = i0.ɵccf("ion-menu", i3.Menu, View_Menu_Host_0, { content: "content", id: "id", type: "type", enabled: "enabled", side: "side", swipeEnabled: "swipeEnabled", persistent: "persistent", maxEdgeStart: "maxEdgeStart" }, { ionDrag: "ionDrag", ionOpen: "ionOpen", ionClose: "ionClose" }, ["*"]);
export { MenuNgFactory as MenuNgFactory };
//# sourceMappingURL=menu.ngfactory.js.map


// WEBPACK FOOTER //
// ./node_modules/ionic-angular/components/menu/menu.ngfactory.js.pre-build-optimizer.js